import { render, staticRenderFns } from "./messagePush.vue?vue&type=template&id=42d9e13e&scoped=true"
import script from "./messagePush.vue?vue&type=script&lang=js"
export * from "./messagePush.vue?vue&type=script&lang=js"
import style0 from "./messagePush.vue?vue&type=style&index=0&id=42d9e13e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d9e13e",
  null
  
)

export default component.exports